var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_setup.isFramed)?_c('NavBar'):_vm._e(),_vm._v(" "),_c('main',[_c('nuxt')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }